import Default from "./ErrorBoundary";
export * from "./ErrorBoundary";

export default Default;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/ErrorBoundary/index.ts